import { PMCAdType, SeoPageAdType } from '@/interfaces';

export const pmcAdSlots: Record<PMCAdType, string> = {
  [PMCAdType.TOP_OF_PMC_PAGE]: '7742891862',
  [PMCAdType.LEFT_SECTION]: '6376741827',
  [PMCAdType.RIGHT_SECTION]: '1643289894',
};

export const seoPageAdSlots: Record<SeoPageAdType, string> = {
  [SeoPageAdType.TOP]: '5381165282',
  [SeoPageAdType.MIDDLE]: '2802998205',
  [SeoPageAdType.BOTTOM]: '3031063061',
};
